import {navigation} from "@/core/navigation/Navigation";
import Component from "vue-class-component";
import Vue from "vue";

@Component
export default class FloteComponent extends Vue {
    navigation = navigation;
}
